export const OSM = {
    Layer: 'osm.layer',
    Colored: 'osm.colored',
    Opacity: 'osm.opacity',
    FAI: 'osm.fai',
};

export const Region = {
    confirmChange: 'region.confirm-change',
};
